import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { TLogo } from '../Header.types';

export const HeaderLogo = ({ logo, logoHeightOverride, logoWidthOverride }: TLogo) => (
  <Link href="/">
    <a>
      <Image
        width={logoWidthOverride || 120}
        height={logoHeightOverride || 23}
        src={logo.filename}
        alt={logo.alt}
      />
    </a>
  </Link>
);
